module.exports = __webpack_public_path__ + "img/slider2.a95be43a.gif";